import { Box, IconMenuEllipseHorizontal32, Stack, Text } from '@stitch-fix/mode-react';
import { useWardrobeCopy } from '../../../utils/contexts/copy-provider';
import { WardrobeCopyFragment } from '../../../utils/hooks/getWardrobeCopy';

/**
 * This is the text that is displayed for both, rebranded and legacy versions and it can be reused.
 */
const StackedText = (copy: WardrobeCopyFragment) => {
  return <Stack>
      <Text setting="title-small" align={{
      sm: 'left',
      md: 'center'
    }}>
        {copy.topItemsModuleEmptyStateHeading}
      </Text>
      <Text setting="body-medium" align={{
      sm: 'left',
      md: 'center'
    }} color="gray-35" my="10px">
        Use the{' '}
        <IconMenuEllipseHorizontal32 purpose="standalone" title="horizontal ellipse" style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        backgroundColor: '#f2f3f4',
        borderRadius: '50%'
      }} />{' '}
        icon to tell us
      </Text>
      <Text setting="body-medium" color="gray-35" align={{
      sm: 'left',
      md: 'center'
    }}>
        {copy.topItemsModuleEmptyStateSubheading}
      </Text>
    </Stack>;
};

/**
 * <TopItemsEmptyState /> handles the display of the top items content if the user has not marked any top items.
 */
const TopItemsEmptyState = () => {
  const {
    copy
  } = useWardrobeCopy();
  return <Box bgColor="gray-99" style={{
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }} p={{
    sm: 1.5,
    md: 1
  }} height="233px">
      {StackedText(copy)}
    </Box>;
};
export default TopItemsEmptyState;